export default __webpack_public_path__ + "static/media/listbuilder-world-selected.b44160f1.svg";